import { computed } from 'vue';
import { useVm } from './useVm';

export function useVuetify() {
  return useVm().$vuetify;
}

export function useIsMobile() {
  const vuetify = useVuetify();
  return computed(() => vuetify.breakpoint.xs);
}
